<script setup>
import { useNotificationStore } from '~/stores/notifications'
import { useOrderEvents } from '~/composables/useOrderEvents'

const notificationStore = useNotificationStore()
const { stopNotificationSound } = useOrderEvents()
const router = useRouter()

const notifications = computed(() => notificationStore.allNotifications)

const removeNotification = (notificationId) => {
  notificationStore.removeNotification(notificationId)
}

const markRead = (notificationIds) => {
  notificationIds.forEach(id => {
    notificationStore.markAsRead(id)
  })
}

const markUnRead = (notificationIds) => {
  notificationIds.forEach(id => {
    const notification = notificationStore.notifications.find(n => n.id === id)
    if (notification) {
      notification.isSeen = false
    }
  })
}

const handleNotificationClick = (notification) => {
  if (!notification.isSeen) {
    notificationStore.markAsRead(notification.id)
  }

  stopNotificationSound()

  if (notification.link) {
    router.push(notification.link)
  }
}
</script>

<template>
  <Notifications
    :notifications="notifications"
    @remove="removeNotification"
    @read="markRead"
    @unread="markUnRead"
    @click:notification="handleNotificationClick"
  />
</template>
